import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { useModal } from "@ebay/nice-modal-react";

const CreateCompanyButton = ({ onClose }) => {
  const modal = useModal("CompanyDrawer");

  return (
    <>
      <Tooltip title="Create new company">
        <IconButton
          variant="contained"
          size="small"
          onClick={() => modal.show({ formType: "create" }).then(onClose)}
        >
          <AddCircleIcon />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default CreateCompanyButton;
